export default {
  back: 'Back',
  refresh: 'Refresh',
  backHome: 'Back Home',
}
